import React, { useEffect, useState } from "react";
import {
  PROJECT_LEVEL_PLACEMENT_END,
  PROJECT_LEVEL_PLACEMENT_START,
  normalizeProjectLevelPlacement,
} from "./projectsScheduleHelpers";
import "./AddWorkTypeModal/AddWorkTypeModal.css";

export const PlacementToggle = ({ value, onChange, disabled = false }) => {
  const placement = normalizeProjectLevelPlacement(value);
  return (
    <div className="psd-placement-toggle" role="group" aria-label="Положение в списке">
      <button
        type="button"
        className={placement !== PROJECT_LEVEL_PLACEMENT_END ? "is-active" : ""}
        disabled={disabled}
        onClick={() => onChange(PROJECT_LEVEL_PLACEMENT_START)}
      >
        В начале
      </button>
      <button
        type="button"
        className={placement === PROJECT_LEVEL_PLACEMENT_END ? "is-active" : ""}
        disabled={disabled}
        onClick={() => onChange(PROJECT_LEVEL_PLACEMENT_END)}
      >
        В конце
      </button>
    </div>
  );
};

const ProjectLevelGroupModal = ({
  open,
  group = null,
  submitting = false,
  error = "",
  onClose,
  onSubmit,
}) => {
  const isEdit = Boolean(group);
  const [name, setName] = useState("");
  const [placement, setPlacement] = useState(PROJECT_LEVEL_PLACEMENT_START);
  const [nameError, setNameError] = useState("");

  useEffect(() => {
    if (!open) return;
    setName(group?.name || "");
    setPlacement(normalizeProjectLevelPlacement(group?.placement));
    setNameError("");
  }, [open, group]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape" && !submitting) onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, submitting, onClose]);

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = String(name || "").trim();
    if (!trimmed) {
      setNameError("Укажите название блока");
      return;
    }
    onSubmit({
      name: trimmed,
      placement: normalizeProjectLevelPlacement(placement),
      group,
    });
  };

  return (
    <>
      <div
        className="add-work-type-modal-backdrop"
        onClick={() => !submitting && onClose()}
      />
      <div
        className="add-work-type-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="project-level-group-modal-title"
      >
        <h2
          id="project-level-group-modal-title"
          className="add-work-type-modal__title"
        >
          {isEdit ? "Блок вне разделов" : "Добавить вне разделов"}
        </h2>
        <div className="add-work-type-modal__hint">
          <span className="add-work-type-modal__hint-icon" aria-hidden>
            ⚠
          </span>
          <p>
            Блок не входит в % завершения РП. Можно поставить его в начало или
            в конец списка разделов и дать своё название.
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <label className="add-work-type-modal__label" htmlFor="plg-name">
            Название
          </label>
          <input
            id="plg-name"
            className="add-work-type-modal__input"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setNameError("");
            }}
            placeholder="Например, Старт РП"
            disabled={submitting}
            autoFocus
          />
          {nameError && (
            <p className="add-work-type-modal__error">{nameError}</p>
          )}

          <div className="add-work-type-modal__label" style={{ marginTop: 16 }}>
            Положение в списке разделов
          </div>
          <PlacementToggle
            value={placement}
            onChange={setPlacement}
            disabled={submitting}
          />

          {error ? (
            <p className="add-work-type-modal__error">{error}</p>
          ) : null}

          <div className="add-work-type-modal__actions">
            <button
              type="button"
              className="add-work-type-modal__btn add-work-type-modal__btn--cancel"
              onClick={onClose}
              disabled={submitting}
            >
              Отмена
            </button>
            <button
              type="submit"
              className="add-work-type-modal__btn add-work-type-modal__btn--submit"
              disabled={submitting}
            >
              {submitting ? "Сохранение..." : isEdit ? "Сохранить" : "Добавить"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ProjectLevelGroupModal;
